




















import AppSvgIcon from '@/uikit/components/AppSvgIconNew';
import { steppersUtils } from '@/uikit/components/AppSteppers/utils';

export default {
  name: 'HeadStepItem',
  components: { AppSvgIcon },
  props: {
    steps: {},
    stepName: {},
    activeStepName: {},
    invalidSteps: {
      type: Object,
    },
  },
  data() {
    return {
      util: steppersUtils(this.steps),
    };
  },
  computed: {
    iconType() {
      let icon = {
        name: null,
        color: 'ui_color__blue-info',
      };
      if (
        this.util.getIndexByName(this.stepName) <
        this.util.getIndexByName(this.activeStepName)
      ) {
        icon.name = this.$ui.IconSvgComponents.approvedAcceptSlim;
        icon.color = 'ui_color__green-successful';
      }
      if (this.stepName === this.activeStepName) {
        icon.name = this.$ui.IconSvgComponents.editCircleSlim;
        icon.color = 'ui_color__blue-info';
      }
      // if (this.indexStepValue === this.invalidSteps.stepNumber) {
      //   icon.name = this.$ui.IconSvgComponents.errorCircleSlim;
      //   icon.color = 'ui_color__red-error';
      // }
      return icon;
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/components/AppSteppers/components/HeadStepItem.vue